import { useCallback, useState } from "react";

import * as service from "../services/creatorPopsService";

export const useCreatorPopUpload = () => {
  const [loadingUploadUrls, setLoadingUploadUrls] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const getCreatorPopUploadUrls = useCallback(async () => {
    setLoadingUploadUrls(true);
    setUploadError("");

    try {
      const [videoS3Data, thumbnailS3Data] = await Promise.all([
        service.getCreatorPopVideoUploadUrl(),
        service.getCreatorPopThumbnailUploadUrl(),
      ]);

      if (!videoS3Data || !thumbnailS3Data) {
        throw new Error("Invalid S3 upload URL response.");
      }

      if (videoS3Data.success === false) {
        throw new Error(
          videoS3Data.message || "Unable to get video upload URL.",
        );
      }

      if (thumbnailS3Data.success === false) {
        throw new Error(
          thumbnailS3Data.message || "Unable to get thumbnail upload URL.",
        );
      }

      return {
        videoS3Data,
        thumbnailS3Data,
      };
    } catch (error) {
      console.error("getCreatorPopUploadUrls failed:", error);

      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to get Pop upload URLs.";

      setUploadError(message);

      return false;
    } finally {
      setLoadingUploadUrls(false);
    }
  }, []);

  return {
    loadingUploadUrls,
    uploadError,
    getCreatorPopUploadUrls,
  };
};

export default useCreatorPopUpload;
